export default "__VITE_ASSET__9635d973__"